module.exports = __webpack_public_path__ + "static/media/burger_icon.92a1ccf8.svg";